import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import constant from '../../constant';
import HospitalForm from '../ui/hospitalForm';

const AddHospital = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    navigate('/hospitals');
  };

  const handleSubmit = async (hospitalData) => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      const apiData = {
        name: hospitalData.name,
        street: hospitalData.street,
        city: hospitalData.city,
        state: hospitalData.state,
        pincode: hospitalData.pincode,
        logo: hospitalData.logo,
        is_active: hospitalData.is_active,
      };

      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData),
      });

      const result = await response.json();
      if (response.ok) {
        navigate('/admin/hospitals');
      } else {
        setError(result.message || 'Failed to add hospital');
      }
    } catch (error) {
      setError('Error adding hospital');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4">
            <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
              <ArrowLeft className="h-6 w-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Add Hospital</h2>
          </div>
        </div>
        {loading && (
          <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
            Processing...
          </div>
        )}
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}
        <HospitalForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default AddHospital;